function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomSmokingOrNoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 25h14v-2H3.1A1.1 1.1 0 002 24.1v4.8A1.1 1.1 0 003.1 30H18v-2H4v-3zM19 30v-7h2v7h-2zM22 30v-7h2v7h-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.356 17.01c3.07 0 5.566 2.239 5.566 4.99H24c0-3.857-3.429-6.993-7.644-6.993-1.256 0-2.278-.9-2.278-2.007H12c0 2.212 1.953 4.01 4.356 4.01z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.644 17.99c-3.07 0-5.566-2.239-5.566-4.99H9c0 3.857 3.429 6.994 7.644 6.994 1.256 0 2.278.9 2.278 2.006H21c0-2.212-1.954-4.01-4.356-4.01z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.454 12.088v-.707c0-.485.042-.915.125-1.29.097-.388.25-.748.458-1.081.208-.347.485-.68.832-.999.457-.416.763-.783.915-1.102.167-.319.25-.68.25-1.082 0-.54-.139-.95-.416-1.227-.264-.291-.666-.437-1.207-.437-1.012 0-1.782.423-2.309 1.27L22 3.517C22.846 2.506 24.038 2 25.578 2c1.248 0 2.212.326 2.891.978.693.651 1.04 1.56 1.04 2.724 0 .666-.11 1.255-.333 1.769-.208.499-.59.998-1.144 1.497-.333.305-.59.583-.77.832a2.356 2.356 0 00-.353.728 4.18 4.18 0 00-.083.895v.665h-2.372zm1.186 4.722c-.444 0-.811-.132-1.102-.395-.278-.278-.416-.638-.416-1.082v-.416c0-.444.138-.797.416-1.06.29-.278.658-.417 1.102-.417.458 0 .825.139 1.102.416.278.264.416.617.416 1.061v.416c0 .444-.138.804-.416 1.082-.277.263-.644.395-1.102.395z",
    fill: props.color
  }));
}

export default SvgIconRoomSmokingOrNoFilled;